import React, { memo } from 'react';
import { Text } from 'rebass';
import { checkIsIpadUser } from 'story-media/hooks';

function TextLayer({
  zoom,
  value,
  isFromBookCover,
  renderedAsChild,
  randomBorder,
  selectedLayer,
  layerId,
  ...props
}) {
  const fontSize = props?.fontSize?.replaceAll('px', '');
  const isIpadUser = checkIsIpadUser();

  return (
    <Text
      onClick={props?.onMediaClick && props?.pageId === props?.currentPage?.id ? () => props?.onMediaClick(props) : undefined}
      sx={{
        bg: (selectedLayer && selectedLayer?.id === layerId) ? 'rgba(125, 194, 255, 0.50)' : undefined,
        position: (isFromBookCover || renderedAsChild) ? 'relative' : 'absolute',
        writingMode: 'horizontal-tb',
        fontFeatureSettings: `"kern" 0,"calt" 0,"liga" 0,"clig" 0,"dlig" 0,"hlig" 0`,
        WebkitFontSmoothing: 'subpixel-antialiased',
        MozOsxFontSmoothing: 'grayscale',
        WebkitTextSizeAdjust: 'auto',
        MozTextSizeAdjust: 'auto',
        msTextSizeAdjust: 'auto',
        textSizeAdjust: 'auto',
        contain: 'style',
        direction: 'ltr',
        WebkitFontKerning: 'none',
        fontKerning: 'none',
        fontSynthesis: 'none',
        WebkitFontVariantLigatures: 'none',
        fontVariantLigatures: 'none',
        letterSpacing: '0',
        overflow: 'visible',
        overflowWrap: 'break-word',
        padding: '0px !important',
        margin: '0px !important',
        MozTabSize: '4',
        OTabSize: '4',
        tabSize: '4',
        textTransform: 'none',
        fontSize: isIpadUser ? `${(fontSize / 100) * zoom}px` : `${fontSize}px`,
        fontFamily: `${props?.fontFamily} !important`,
        fontWeight: props?.fontWeight,
        textAlign: props?.fontAlignment,
        fontStyle: props?.fontStyle,
        textDecoration: props?.['font-decoration'] || 'none',
        color: props?.color,
        width: `${props.width}px`,
        height: `${props.height}px`,
        verticalAlign: props['vertical-alignment'],
        zIndex: props['render-order'] || 2,
        // lineHeight: `${props['font-line-height']}px`,
        wordBreak: 'break-word',
        outline: 'none',
        left: `${props.xpos}px`,
        top: `${props.ypos}px`,
        touchAction: 'pan-x pan-y pinch-zoom',
        border: randomBorder,
        'p': {
          margin: '0 !important'
        }
      }}
      dangerouslySetInnerHTML={{ __html: props?.text }}
    />
  );
}

export default memo(TextLayer);
